import React from 'react';

// Components
import MuiKpiPaper from '../../../../components/muikpipaper';
// Models
import type { KpiGrid } from '../../../../models/operationsmodels/KpiModels';

interface MarketingProps {
  /** Pre-fetched data for print view — skips Redux read when provided */
  data?: KpiGrid[];
  /** When true, renders all grids flat without tabs or interactive controls */
  isPrintView?: boolean;
}

/**
 * Marketing Component - Wrapper for Marketing KPI display
 */
const Marketing: React.FC<MarketingProps> = ({ data, isPrintView }) => {
  return <MuiKpiPaper cardTitle="Marketing" data={data} isPrintView={isPrintView} />;
};

export default Marketing;
